// extracted by mini-css-extract-plugin
export default {"card":"xTl0c","category":"DTa8W","title":"_63kXq","topShadow":"_7DzcJ","button":"P-Zgh","buttonIcon":"f5l7x"};